// UID: NPO-BDGT-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import IsForProfit from '../rules/IsForProfit';
import { RulesetResult } from '../rules/';

class PriorYearBudgetRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isNonProfit = !IsForProfit.evaluate(data);
    if (isNonProfit) return RulesetResult.OPTIONAL;
    return RulesetResult.HIDDEN;
  };
}

export default new PriorYearBudgetRuleset();
